import { FeatureToggleName } from '../FeatureToggleTypes';

export type FeatureTogglesMeResponse = Partial<Record<FeatureToggleName, boolean>>;
